// Only individual automatic confirmations earn points. Batch confirmations are
// remembered so revisiting a clue cannot earn a second point.
export function createWordStreak() {
  const confirmed = new Set();
  let count = 0;
  return {
    confirmed,
    get count() { return count; },
    accept(key, correct) {
      if (confirmed.has(key)) return null;
      if (!correct) { count = 0; return null; }
      confirmed.add(key);
      count += 1;
      return [3, 5, 10].includes(count) ? count : null;
    },
    // Silent restore from saved progress: never returns a milestone, so no audio replays.
    restore(savedCount, keys) {
      (keys || []).forEach(key => confirmed.add(key));
      count = Number.isInteger(savedCount) && savedCount > 0 ? savedCount : 0;
    },
    batch(keys, hasIncorrectWord) {
      keys.forEach(key => confirmed.add(key));
      if (hasIncorrectWord) count = 0;
    },
  };
}
